import IncidentForm from "../../../../components/Forms/incidentForm";
import { TabOptions } from "../../../../types/fieldInstance.interface";

const PatientDemographics = () => {
  return (
    <div>
      <IncidentForm tabTitle={TabOptions.PatientDemographics} />
    </div>
  );
};

export default PatientDemographics;
